<template>
  <crud-show fullscreen :title="title" :open="open" @close="$emit('close')">

    <v-card-text>
      <show-order :identifier="item.identifier"></show-order>
    </v-card-text>

  </crud-show>
</template>

<script>
import {CrudShow} from '@dracul/common-frontend'
import ShowOrder from "@/modules/delivery/components-core/shared/ShowOrder/ShowOrder";

export default {
  name: "OrderShow",
  components: {ShowOrder, CrudShow},
  props: {
    open: {type: Boolean, default: true},
    item: {type: Object, required: true}
  },
  data() {
    return {
      title: 'delivery.order.showing',
    }
  },
}
</script>

